import { TextControl as WPTextControl } from '@wordpress/components';

const TextControl = ({ field, value, ...restAttr }) => {

    const { className, ...remainingAttr } = restAttr;

    return (
        <WPTextControl
            label={field.label}
            type={field.type}
            value={value}
            className={className}
            __next40pxDefaultSize
            __nextHasNoMarginBottom
            {...remainingAttr}
        />
    );
};

export default TextControl;